import '../static/Container.css';
import React__default, { forwardRef } from "react";
import clsx from "clsx";
import { a as Grid } from "./Grid.QyNjlydO.mjs";
const container = `_container_5c7d837`;
const sm = `_sm_ce29648`;
const lg = `_lg_21d753f`;
const full = `_full_8a0e899`;
const styles = { container, sm, lg, full };
const CONTAINER_SIZE_VARIANTS = ["lg", "sm", "full"];
const ContainerInner = ({ className, size = "lg", ...props }, ref) => {
  return /* @__PURE__ */ React__default.createElement(
    Grid,
    {
      ref,
      "data-ui-container": true,
      className: clsx(styles.container, styles[size], className),
      ...props
    }
  );
};
const Container = forwardRef(
  ContainerInner
);
export {
  CONTAINER_SIZE_VARIANTS as C,
  Container as a
};
//# sourceMappingURL=Container.CXMIxriX.mjs.map
